/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import { Box, Modal, Grid, Tooltip } from '@mui/material';
import Draggable from 'react-draggable';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { Button } from '@mui/base';
import Createpdf from '../CIPReport_generate';
import { closeIconBlack, print_image } from '../../../shared/assets/images';
import { defaultModalOptions } from '../../../shared/constantVariable';
import Notification from '../../../shared/notification-modal';

import './cip-report-view.scss';

const ReportCipPopup = (props) => {
  const { visibleQuickView, closeQuickViewPopup, cipReportData, reportDataObj, translateObject, units, isVolumeDisabled, setCipNotification, dbTransactionDetails, setFetchLoading } = props;
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [cipPdfReport, setCipPdfReport] = useState(false);
  useEffect(() => {
  }, []);
  const getcleaningStep = (val) => {
    let arr = Object.keys(dbTransactionDetails.cip_dict);
    arr = arr.map((ele) => {
      return { label: ele, value: ele.replace(/\s/g, '') };
    });
    const data = arr.filter((ele) => {
      return val.indexOf(ele.value) >= 0;
    });
    if (data.length > 0) {
      const pdflink = data[0].label;
      return { str: val, link: dbTransactionDetails.cip_dict[pdflink] };
    }
    if (val.toLowerCase() === 'cleaner not available') {
      val = 'Cleaner not available';
    }
    return { str: val, link: '' };
  };

  return (
    <Draggable handle='.cip-report-view-box' cancel='.cancel-draggable'>
      <Modal
        hideBackdrop
        open={visibleQuickView}
        onClose={closeQuickViewPopup}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        className="quick-view-modal"
      >
        <Box className='cip-report-view-box' display="flex">
          <Notification
            options={modalOption}
            handleClose={() => setModalOption(defaultModalOptions)}
          />
          <Grid container className='quick-view-grid-container'>
            <Grid item xs={12} className='quick-view-header'>
              <div className='quick-view-header-text ft rufusBld cancel-draggable L_Bold'>{translateObject('CIP Report')}</div>
              <div className='quick-view-close-icon cancel-draggable'>
                <Tooltip title="Close">
                  <img src={closeIconBlack} alt="close" onClick={closeQuickViewPopup} style={{ display: 'block' }} className="pointer" />
                </Tooltip>
              </div>
            </Grid>
            <Grid item xs={12} className='quick-view-body-container sansW4SeLig'>
              <Box sx={{ width: '100%', typography: 'body1' }} className='mixer-box-container'>
                <div className="quick-view-content">
                  <div className='quick-view-data cancel-draggable S_Regular'>
                    <ul className='quick-view-data-header'>
                      <li />
                      <li>{translateObject('Stage')} 1</li>
                      <li>{translateObject('Stage')} 2</li>
                      <li>{translateObject('Stage')} 3</li>
                      <li>{translateObject('Total')}</li>
                    </ul>
                    <div className='quick-view-data-wrapper'>
                      <ul className='quick-view-data-containt'>
                        <li className='M_Bold' style={{ width: 138.5 }}>{translateObject('Cleaning Step')} 1</li>
                        <li className='cleanigstage'>
                          {(() => {
                            const obj = getcleaningStep(cipReportData.clean_display_1);
                            if (obj.link) return <a href={obj.link}>{obj.str}</a>;
                            return obj.str;
                          })()}
                        </li>
                      </ul>
                      <ul className='quick-view-data-containt'>
                        <li>{translateObject('Quantity of Cleaner')} ({(units['Liquid Volume'] === 'gal' || units['Liquid Volume'] === 'ft3') ? 'lbs' : 'kgs'})</li>
                        {(() => {
                          if (cipReportData.results.cleaning_step.Step_1) {
                            const data = Object.values(cipReportData.results.cleaning_step.Step_1);
                            if (data.length === 1) {
                              data.push('', '');
                            }
                            if (data.length === 2) {
                              data.push('');
                            }
                            return data.map((ele) => {
                              return (<li>{ele || '-'}</li>);
                            });
                          }
                          return [0, 1, 2].map(() => { return <li className='blank' />; });
                        })()}
                        <li>{(() => {
                          if (cipReportData.results.cleaning_step_total.Step_1) {
                            return cipReportData.results.cleaning_step_total.Step_1.toFixed(2);
                          }
                          return '-';
                        })()}</li>
                      </ul>
                      <ul className='quick-view-data-containt surface-L1'>
                        <li className='M_Bold' style={{ width: 138.5 }}>{translateObject('Cleaning Step')} 2</li>
                        <li className='cleanigstage'>
                          {(() => {
                            const obj = getcleaningStep(cipReportData.clean_display_2);
                            if (obj.link) return <a href={obj.link}>{obj.str}</a>;
                            return obj.str;
                          })()}
                        </li>
                      </ul>
                      <ul className='quick-view-data-containt surface-L1'>
                        <li>{translateObject('Quantity of Cleaner')} ({(units['Liquid Volume'] === 'gal' || units['Liquid Volume'] === 'ft3') ? 'lbs' : 'kgs'})</li>
                        {(() => {
                          if (cipReportData.results.cleaning_step.Step_2) {
                            const data = Object.values(cipReportData.results.cleaning_step.Step_2);
                            if (data.length === 1) {
                              data.push('', '');
                            }
                            if (data.length === 2) {
                              data.push('');
                            }
                            return data.map((ele) => {
                              return (<li>{ele || '-'}</li>);
                            });
                          }
                          return [0, 1, 2].map(() => { return <li className='blank' />; });
                        })()}
                        <li>{(() => {
                          if (cipReportData.results.cleaning_step_total.Step_2) {
                            return cipReportData.results.cleaning_step_total.Step_2.toFixed(2);
                          }
                          return '-';
                        })()}</li>
                      </ul>
                      <ul className='quick-view-data-containt'>
                        <li className='M_Bold' style={{ width: 138.5 }}>{translateObject('System Design')}</li>
                        <li className={`${cipReportData.clean_display_3 ? 'link-report' : ''}`}>{cipReportData.clean_display_3}</li>
                      </ul>
                      <ul className='quick-view-data-containt'>
                        <li>{translateObject('Pump Flow rate')} ({units['Volume Flow']})</li>
                        {Object.values(cipReportData.results.stage_pump_flowrate).map((ele, i) => {
                          return (<li>
                            {(i === 0 || ele === '') && isVolumeDisabled && <QuestionMarkIcon onClick={() => { setCipNotification(true); }} style={{ color: '#2d2d2d', fontSize: 10, cursor: 'pointer' }} />}
                            {ele}</li>);
                        })}
                        {Object.values(cipReportData.results.stage_pump_flowrate).length === 1 && <>{isVolumeDisabled && <li className='1' >
                          <QuestionMarkIcon onClick={() => { setCipNotification(true); }} style={{ color: '#2d2d2d', fontSize: 10, cursor: 'pointer' }} /></li>}{isVolumeDisabled && <li className='1' ><QuestionMarkIcon onClick={() => { setCipNotification(true); }} style={{ color: '#2d2d2d', fontSize: 10 }} /></li>}</>}
                        {Object.values(cipReportData.results.stage_pump_flowrate).length === 1 && !isVolumeDisabled && <><li className='blank' /><li className='blank' /></>}
                        {Object.values(cipReportData.results.stage_pump_flowrate).length === 2 && isVolumeDisabled && <li className='1' >
                          <QuestionMarkIcon onClick={() => { setCipNotification(true); }} style={{ color: '#2d2d2d', fontSize: 10, cursor: 'pointer' }} /></li>}
                        {Object.values(cipReportData.results.stage_pump_flowrate).length === 2 && !isVolumeDisabled && <li className='blank' />}
                        <li>{cipReportData.results.total_pump_flowrate}</li>
                      </ul>
                      <ul className='quick-view-data-containt'>
                        <li>{translateObject('Solution Volume')} ({units['Liquid Volume']})</li>
                        {Object.values(cipReportData.results.stage_solution_volume).map((ele) => {
                          return (<li>{ele}</li>);
                        })}
                        {Object.values(cipReportData.results.stage_solution_volume).length === 1 && <><li className='blank' /><li className='blank' /></>}
                        {Object.values(cipReportData.results.stage_solution_volume).length === 2 && <li className='blank' />}
                        <li>{cipReportData.results.total_solution_volume}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </Box>
              <Grid xs={12}>
                <div className='print-cip-report-wrpper'>
                  <Button variant="contained" className="sansW4SeLig M_Bold Primary_Default_Button " size="small" onClick={() => { setFetchLoading(true); setCipPdfReport(true); }}> {translateObject('Print')} <img style={{ marginLeft: 5 }} src={print_image} className="img-top" alt='units_color' /> </Button>
                  <Button variant="contained" className="sansW4SeLig M_Bold Secondary-Default_button " size="small" onClick={closeQuickViewPopup}> {translateObject('Cancel')} </Button>
                </div>
                {cipPdfReport && (
                  <Createpdf
                    setCipPdfReport={setCipPdfReport}
                    cipReportData={cipReportData}
                    reportDataObj={reportDataObj}
                    setFetchLoading={setFetchLoading}
                  />)}
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Draggable>
  );
};
export default ReportCipPopup;
